import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Heart, UserCheck } from 'lucide-react';
export function About() {
  const values = [{
    icon: <UserCheck className="w-6 h-6 text-rosegold" data-id="element-1" />,
    title: 'Profesionalismo',
    description: 'Técnicas de vanguardia y productos de primera línea para resultados impecables.'
  }, {
    icon: <Heart className="w-6 h-6 text-rosegold" data-id="element-2" />,
    title: 'Bienestar integral',
    description: 'Un enfoque holístico donde la belleza exterior se encuentra con la paz interior.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-rosegold" data-id="element-3" />,
    title: 'Experiencia personalizada',
    description: 'Cada tratamiento es adaptado a tus necesidades y estilo único.'
  }];
  return <section id="nosotros" className="py-24 bg-cream" data-id="element-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-7">
            <div className="aspect-[9/16] max-w-sm mx-auto rounded-3xl overflow-hidden relative z-10 border-8 border-white shadow-xl" data-id="element-8">
              <video src="https://cdn.magicpatterns.com/uploads/vSrXNtRwH3WKiTntmZPdvY/SaveClip.App_AQNLTModvRoxZuHLtBD45ajX37TelpMaclLhBpDt58D3UczPDkP2fqoaXNZbRrJD-n1IGSu0DtvsZGzHVYagFsD1hq1FY2lnzICj4Ig.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-9" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-rosegold/10 rounded-full -z-0" data-id="element-10"></div>
            <div className="absolute top-1/4 -right-8 w-32 h-32 bg-subtlegold/10 rounded-full -z-0" data-id="element-11"></div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-12">
            <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-13">
              Quiénes somos
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-charcoal mb-6 leading-tight" data-id="element-14">
              Un refugio de belleza en el corazón de Punta Carretas
            </h3>
            <p className="text-charcoal-light mb-8 text-lg font-light leading-relaxed" data-id="element-15">
              Studio by Mery nació con la visión de crear un espacio donde la
              excelencia técnica se fusiona con una experiencia de relajación
              absoluta. No somos solo un estudio de uñas y pestañas; somos tu
              pausa merecida en la rutina.
            </p>

            <div className="space-y-6" data-id="element-16">
              {values.map((value, index) => <div key={index} className="flex gap-4 items-start" data-id="element-17">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center border border-cream-dark" data-id="element-18">
                    {value.icon}
                  </div>
                  <div data-id="element-19">
                    <h4 className="text-lg font-medium text-charcoal mb-1" data-id="element-20">
                      {value.title}
                    </h4>
                    <p className="text-charcoal-light font-light" data-id="element-21">
                      {value.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}